import { Directive } from "@angular/core";
import {
  AbstractControl,
  FormGroup,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  ValidatorFn,
} from "@angular/forms";

export const compareDateValidator: ValidatorFn = (
  control: FormGroup
): ValidationErrors | null => {
  const accessFrom = control.get("accessFrom");
  const accessTo = control.get("accessTo");

  return accessFrom &&
    accessTo &&
    new Date(accessFrom.value) > new Date(accessTo.value)
    ? { identityRevealed: true }
    : null;
};

@Directive({
  selector: "[appIdentityRevealed]",
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: CompareDateValidatorDirective,
      multi: true,
    },
  ],
})
export class CompareDateValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors {
    return compareDateValidator(control);
  }
}
